import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Features/StaticCategory/components/StaticSearch';
import { fetchTrendingDeals } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'trendingdeals.title',
    defaultMessage: 'Trending Now',
  },
  fullTitle: {
    id: 'trendingdeals.seotitle',
    defaultMessage: 'Trending Now | Best Prices on PC and Steam Games',
  },
  desc: {
    id: 'trendingdeals.seodesc',
    defaultMessage: 'The games everyone is talking about, from brand new releases to long-time favourites! Explore games across diverse genres and get immersed in action-packed adventures, strategic challenges and engaging role-playing experiences. Discover your new favorite today!',
  },
  pcGameDeals: {
    id: 'trendingdeals.pcgamedeals',
    defaultMessage: 'PC Game Deals',
  },
});

export default function TrendingDeals() {
  const { formatMessage } = useIntl();

  const crumbs = [{
    label: formatMessage(messages.pcGameDeals),
    link: '/on-sale/',
  },
  {
    label: formatMessage(messages.title),
    link: '/trending-deals',
  },
  ];

  return (<StaticSearch
    updateHits={fetchTrendingDeals}
    url="trending-deals"
    seoBlurb={messages.desc}
    crumbs={crumbs}
    {...messages}
  />);
}
